import { Utm } from '@hungryroot/segment';

export function UtmWrapper() {
  return <Utm search={window.location.search} />;
}
